import * as yup from "yup";

export const profileSetupSchema = yup.object().shape({
    image: yup.string(),
    address: yup.string().required('Address is required'),
    postalCode: yup.number().required('Postal Code is required'),
}).required();
